import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const CouponsAndPromos = (props) => {
  const { cartOrOrder } = props;

  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { coupons, promotions } = cartOrOrder;

  if (coupons.length === 0 && promotions.length === 0) {
    return null;
  }

  return (
    <div
      className="c7-order-summary__discounts"
      role="group"
      aria-label={t('general.accessibility.checkoutDiscountSummary')}
    >
      {coupons.map((coupon) => {
        if (!coupon.inUse) {
          return null;
        }
        return (
          <CouponOrPromotion
            couponOrPromotion={coupon}
            currency={currency}
            key={coupon.id}
          />
        );
      })}
      {promotions.map((promotion) => {
        if (!promotion.inUse) {
          return null;
        }
        return (
          <CouponOrPromotion
            couponOrPromotion={promotion}
            currency={currency}
            key={promotion.promotionId}
          />
        );
      })}
    </div>
  );
};

const CouponOrPromotion = (props) => {
  const { couponOrPromotion, currency } = props;
  const { t } = useLocalization();

  return (
    <div className="c7-order-summary__discount">
      <div className="c7-order-summary__title">
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
          <line x1="7" y1="7" x2="7.01" y2="7" />
        </svg>
        {couponOrPromotion.title}
      </div>
      <div className="c7-order-summary__value">
        {currencyFormat(couponOrPromotion.totalValue, currency)}{' '}
        {t('checkout.general.saved')}
      </div>
    </div>
  );
};

export default CouponsAndPromos;

//
// import { currencyFormat } from 'common/helpers/numberHelper';
// import { isShowSavings } from 'common/helpers/featureFlags';

//   return (
//     <div className="c7-cart__promo__summary">
//       <ul>
//         {coupons.map((coupon) => {
//           if (coupon.inUse) {
//             return (
//               <li key={coupon.id}>
//                 The coupon{' '}
//                 <span className="c7-discount-title">{coupon.title}</span> has
//                 been applied.{' '}
//                 {isShowSavings() && (
//                   <span className="c7-discount-amount">
//                     Your savings: {currencyFormat(coupon.totalValue, settings)}
//                   </span>
//                 )}
//               </li>
//             );
//           }
//           switch (coupon.invalidReason) {
//             case 'Not applicable for customer': {
//               return (
//                 <li key={coupon.id}>
//                   The coupon{' '}
//                   <span className="c7-discount-title">{coupon.title}</span> is
//                   not applicable for your customer group.
//                 </li>
//               );
//             }
//             case 'Order does not meet requirements': {
//               return (
//                 <li key={coupon.id}>
//                   Your order does not meet the minimum requirements for coupon{' '}
//                   <span className="c7-discount-title">{coupon.title}</span>.
//                 </li>
//               );
//             }
//             case 'No applicable products in cart': {
//               return (
//                 <li key={coupon.id}>
//                   There are no applicable products in your cart for coupon{' '}
//                   <span className="c7-discount-title">{coupon.title}</span>.
//                 </li>
//               );
//             }
//             case 'No applicable shipping in cart': {
//               if (cart.shipping.length === 0) {
//                 return (
//                   <li key={coupon.id}>
//                     Coupon{' '}
//                     <span className="c7-discount-title">{coupon.title}</span>{' '}
//                     will not apply until a shipping method is selected.
//                   </li>
//                 );
//               }
//               return (
//                 <li key={coupon.id}>
//                   Coupon{' '}
//                   <span className="c7-discount-title">{coupon.title}</span> is
//                   not applicable for the shipping method selected.
//                 </li>
//               );
//             }
//             case 'Other coupon applicable': {
//               return (
//                 <li key={coupon.id}>
//                   Alternate coupon is in use. Coupon{' '}
//                   <span className="c7-discount-title">{coupon.title}</span> is
//                   not applicable.
//                 </li>
//               );
//             }
//             default: {
//               return (
//                 <li key={coupon.id}>
//                   The coupon{' '}
//                   <span className="c7-discount-title">{coupon.title}</span> is
//                   not applicable.
//                 </li>
//               );
//             }
//           }
//         })}
//         {promotions.map((promo) => (
//           <li key={promo.id}>
//             <span className="c7-discount-title">{promo.title}</span> is in
//             effect.{' '}
//             {isShowSavings() && (
//               <span className="c7-discount-amount">
//                 Your savings: {currencyFormat(promo.totalValue, settings)}
//               </span>
//             )}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default CouponsAndPromos;
